import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    tournament_areas: [],
    tournament_area: {}
  },
  mutations: {
    index(state, payload) {
      state.tournament_areas = payload
    },
    show(state,payload) {
      state.tournament_area = payload
    },
    update(state, payload) {
      state.tournament_area = payload
    },
    create(state, payload) {
      state.tournament_area = payload
      state.tournament_areas.push(payload)
    }
  },
  actions: {
    index ({commit}, payload) {
      return axios.get(`${ENV.API_URL}/api/tournament_areas${payload}`).then((res) => {
        commit('index', res.data)
        return (res.data)
      })
    },
    show({commit}, payload) {
      return axios.get(`${ENV.API_URL}/api/tournament_areas/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({commit}, payload) {
      return axios.post(`${ENV.API_URL}/api/tournament_areas`, payload).then((res) => {
        commit('create', res.data)
      })
    },
    update({commit}, payload) {
      return axios.put(`${ENV.API_URL}/api/tournament_areas/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    tournament_areas: state => {
      return state.tournament_areas
    },
    tournament_area: state => {
      return state.tournament_area
    }
  },
  modules: {
  }
}
